<template>
    <div class="segment-title">
        <v-icon-button
            type="basic"
            tooltip="Toggle segments column"
            @click.stop="toggleSegmentsColumn"
            class="margin-right-s">
            <v-icon icon="collapse-segments"/>
        </v-icon-button>
        <h2 class="display-inline inline-m" data-cy="Segment name">{{activeSegment.data.name}}</h2><r-badge type="info" data-cy="Segment type">{{activeSegment.data.type}}</r-badge>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {vIcon, vIconButton} from '@/components/form';

    export default {
        name: 'segment-title',
        components: {
            vIcon,
            vIconButton,
        },
        computed: {
            ...mapGetters({
                activeSegment: 'segments/activeSegment',
            }),
        },
        methods: {
            ...mapActions({
                toggleSegmentsColumn: 'segments/toggleSegmentsColumn',
                addBreadcrumb: 'router/updateHistory',
            }),
        },
        mounted() {
            if (this.$route.name === 'lists') {
                this.addBreadcrumb({
                    label: this.activeSegment.data.name,
                    fullPath: this.$route.fullPath,
                    route: {
                        name: this.$route.name,
                        params: this.$route.params,
                    },
                    root: true,
                });
            }
        },
    };
</script>
